(() => {
  if (customElements.get('cyco-card-swatches')) return;
  customElements.define('cyco-card-swatches', class extends HTMLElement {
    connectedCallback() {
      if (this.initialised) return;
      this.initialised = true;
      this.addEventListener('click', event => {
        const choice = event.target.closest('.cyco-card-swatches__choice');
        if (!choice || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        event.stopPropagation();
        this.select(choice);
      });
      this.addEventListener('keydown', event => {
        const choice = event.target.closest('.cyco-card-swatches__choice');
        if (choice && event.key === ' ') {
          event.preventDefault();
          this.select(choice);
        }
      });
    }
    select(choice) {
      const card = this.closest('.product-block');
      if (!card) return;
      this.selected = choice;
      this.querySelectorAll('.cyco-card-swatches__choice').forEach(item => item.setAttribute('aria-pressed', String(item === choice)));
      this.querySelector('.cyco-card-swatches__label').textContent = choice.dataset.label;
      const url = choice.getAttribute('href');
      card.querySelectorAll('.product-block__image,.product-block__title-link,.product-block__quicklook-btn,.cyco-card-swatches__more').forEach(link => link.setAttribute('href', url));
      const quickBuy = card.querySelector('.js-quickbuy-button');
      if (quickBuy) {
        quickBuy.classList.remove('js-quickbuy-button');
        quickBuy.textContent = this.dataset.viewOptions;
      }
      const price = card.querySelector('.product-price');
      if (price) {
        price.replaceChildren(this.querySelector('.cyco-card-swatches__price').content.cloneNode(true));
        price.querySelector('[data-cyco-price]').innerHTML = choice.dataset.price;
        price.querySelector('[data-cyco-price]').classList.toggle('product-price__reduced', Boolean(choice.dataset.compare));
        price.querySelector('[data-cyco-compare]').innerHTML = choice.dataset.compare;
        price.querySelector('[data-cyco-compare]').hidden = !choice.dataset.compare;
        price.querySelector('.product-price__from').hidden = choice.dataset.priceVaries !== 'true';
        price.querySelector('[data-cyco-sold-out]').hidden = choice.dataset.available === 'true';
      }
      const imageLink = card.querySelector('.product-block__image');
      if (!imageLink) return;
      let preview = imageLink.querySelector('.cyco-card-swatches__preview');
      if (!preview) {
        preview = document.createElement('div');
        preview.className = 'cyco-card-swatches__preview';
        imageLink.append(preview);
      }
      card.classList.add('cyco-card-has-preview');
      const placeholder = document.createElement('span');
      placeholder.textContent = choice.dataset.image ? this.dataset.loading : this.dataset.noImage.replace('[color]', choice.dataset.color);
      preview.replaceChildren(placeholder);
      if (!choice.dataset.image) return;
      const image = new Image();
      image.alt = choice.dataset.imageAlt;
      image.decoding = 'async';
      image.onload = () => {
        if (this.selected === choice) preview.replaceChildren(image);
      };
      image.onerror = () => {
        if (this.selected === choice) placeholder.textContent = this.dataset.noImage.replace('[color]', choice.dataset.color);
      };
      image.src = choice.dataset.image;
    }
  });
})();
